module.exports = __webpack_public_path__ + "img/car_seat.b3d80264.png";